import React from "react";
import { connect } from "react-redux";
import getMyUserBasicProfile from "../../../../../_selectors/userSelectors/getMyUserBasicProfile";
import BasicDetail from "./BasicDetail";
const Basic = ({ userProfile, update, showToast }) => {
  return (
    <BasicDetail
      userProfile={userProfile}
      update={update}
      toast={showToast}
      showEdit={true}
    />
  );
};

const mapStateToProps = (state, ownProps) => ({
  userProfile: getMyUserBasicProfile(state)
});

export default connect(mapStateToProps)(Basic);



// WEBPACK FOOTER //
// ./src/_components/Profile/Home/ProfileInformation/Basic/index.js